import {orderCancel} from './order-cancel-de.i18n';

export const de = {
  orderCancel,
};
